import { Component, inject } from '@angular/core';
import { UiModule } from '@components/ui/ui-module';
import { Router } from '@services/route.service';

@Component({
  selector: 'lgb-offers',
  imports: [
    UiModule
  ],
  templateUrl: './offers.html',
  styleUrl: './offers.css',
})
export class Offers {
  readonly router=inject(Router);

  placeOrder(){
    this.router.navigate('plan-checkout');
  }
}
